/**
 * Regels rond accounts en uitnodigingen die client en worker delen, zodat het
 * invoerveld dezelfde uitkomst geeft als de server. De server blijft de plek
 * waar het wordt afgedwongen.
 */
/** Trim plus kleine letters. Adressen zijn case-insensitive in de praktijk, en
 *  `User.email` is uniek: zonder normaliseren komt hetzelfde adres er twee keer
 *  in met een hoofdletterverschil. */
export function normaliseerEmail(email) {
    return email.trim().toLowerCase();
}
/** Bewust simpel: één @, iets ervoor, en een domein met een punt erin. Een
 *  strenger patroon dan dit levert vooral valse afwijzingen op. */
const BASIS_PATROON = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Geeft de reden terug waarom dit adres niet kan, of null als het mag. */
export function keurAccountEmail(email) {
    const genormaliseerd = normaliseerEmail(email);
    if (!genormaliseerd)
        return 'Vul een e-mailadres in.';
    if (!BASIS_PATROON.test(genormaliseerd))
        return 'Dit is geen geldig e-mailadres.';
    return null;
}
//# sourceMappingURL=account.js.map